<template>
  <div class="Article" :class="{'Article--open': open}">
    <div
      v-if="data"
      class="Article__cover"
      :style="{backgroundColor: data.color}"
    >
      <header>
        <h2 class="Article__author">{{data.author}}</h2>
        <h1>{{data.title}}</h1>
        <em style="    text-align: right;
    float: right;
    color: #fff;">Nog 2 dagen beschikbaar</em>
      </header>
      <div v-if="!open">
        <div class="Article__arrow">
          <small><em>Begin met lezen</em></small>
        </div>
      </div>
      <router-link v-else to="/" class="Article__close-btn">
        <img src="../assets/close.svg"/>
      </router-link>
    </div>
    <div v-if="open" class="Article__content">
      <div v-html="mdToHtml(data.text)"/>
      <hr/>

      <div class="Article__row">
        <a :href="`https://api.whatsapp.com/send?text=Je moet dit echt lezen, ${data.title} van ${data.author}`"
           target="_blank">
          <img src="../assets/present.png" height="100" width="100"/>
        </a>
        <Star :title="`${data.author} ${data.bundel}`"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Star from './Star'
  import MarkdownIt from 'markdown-it'

  const md = new MarkdownIt()

  export default {
    name: 'Article',
    components: {
      Star
    },
    props: [
      'id'
    ],
    mounted () {
      if (this.isSingle) {
        this.open = true
      }
    },
    methods: {
      mdToHtml (text) {
        return md.render(text)
      }
    },
    computed: {
      data () {
        const id = this.id || this.$route.params.uid
        return this.$store.getters.getArticle(id)
      },
      isSingle () {
        return this.$route.name === 'article'
      }
    },
    data () {
      return {
        open: false
      }
    }
  }
</script>

<style>
  .Article {
    width: 90%;
    margin: 1em auto;
    background-color: #fffee8;
    transition: .4s;
    overflow: hidden;
  }

  .Article h1 {
    font-weight: bold;
    color: #fff;
  }

  .Article--open {
    width: 100%;
    border-radius: 0;
    margin-top: 0;
    min-height: 100%;
  }

  .Article__cover {
    height: calc(100vh - 8em);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    transition: .4s;
    background-size: cover;
    padding: 1em;
    /*background: paleturquoise !important;*/
    position: relative;
  }

  /*.Article__cover::after {*/
  /*content: '';*/
  /*position: absolute;*/
  /*bottom: 0;*/
  /*height: 70%;*/
  /*width: 100%;*/
  /*background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, .8));*/
  /*}*/

  .Article--open .Article__cover {
    height: inherit;
  }

  .Article__cover header {
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .Article__close-btn {
    position: absolute;
    top: 1em;
    right: 1em;
    display: block;
    width: 2em;
    z-index: 5;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .Article__author {
    font-size: 1em;
  }

  .Article__author small {
    color: #bbb;
  }

  .Article__arrow {
    border: 1px solid currentColor;
    padding: 0.5em 1em;
    margin: .5em auto;
    z-index: 1;
    position: relative;
  }

  .Article__content {
    font-size: 1.35em;
    padding: 1.5em;

  }

  .Article__row {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .VueCarousel-slide a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Article.vue